const normalize = (value = '') => value
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9\s]/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const categorySignals = {
  client: [
    'como cliente', 'sou cliente', 'para mim', 'quero agendar',
    'quero marcar', 'quero reservar', 'entrar em uma barbearia',
  ],
  owner: [
    'como barbeiro', 'sou barbeiro', 'como dono', 'sou dono',
    'minha barbearia', 'criar horario', 'adicionar horario',
    'disponibilizar horario', 'colocar um horario', 'abrir horario', 'criar slot',
  ],
};

const includesPhrase = (text, phrase) => text.includes(normalize(phrase));

const inferRequestedCategory = (text) => {
  const normalizedText = normalize(text);
  const scores = Object.entries(categorySignals).map(([category, signals]) => ({
    category,
    score: signals.reduce(
      (total, signal) => total + (includesPhrase(normalizedText, signal) ? 8 : 0),
      0
    ),
  }));
  scores.sort((a, b) => b.score - a.score);
  return scores[0].score > scores[1].score ? scores[0].category : null;
};

const scoreResponse = (text, qa, category, requestedCategory, currentRole) => {
  const normalizedText = normalize(text);
  const normalizedQuestion = normalize(qa.question);
  let score = 0;

  if (normalizedText === normalizedQuestion) score += 30;
  else if (normalizedText.includes(normalizedQuestion) || normalizedQuestion.includes(normalizedText)) score += 8;

  (qa.phrases || []).forEach((phrase) => {
    if (includesPhrase(normalizedText, phrase)) score += 10;
  });

  (qa.keywords || []).forEach((keyword) => {
    const normalizedKeyword = normalize(keyword);
    if (normalizedText.includes(normalizedKeyword)) {
      score += normalizedKeyword.includes(' ') ? 5 : 2;
    }
  });

  (qa.negativeKeywords || []).forEach((keyword) => {
    if (includesPhrase(normalizedText, keyword)) score -= 12;
  });

  if (requestedCategory === category) score += 12;
  if (requestedCategory && requestedCategory !== category) score -= 12;
  if (!requestedCategory && currentRole === 'owner' && category === 'owner') score += 1;

  return score;
};

export const findChatbotMatch = (
  text,
  chatResponses,
  { selectedCategory = null, currentRole = null } = {}
) => {
  const requestedCategory = inferRequestedCategory(text);
  const categories = selectedCategory ? [selectedCategory] : Object.keys(chatResponses);
  const candidates = categories.flatMap((category) =>
    (chatResponses[category] || []).map((qa) => ({
      qa,
      category,
      score: scoreResponse(text, qa, category, requestedCategory, currentRole),
    }))
  ).sort((a, b) => b.score - a.score);

  const best = candidates[0];
  if (!best || best.score < 3) return { type: 'none' };

  const bestOtherCategory = candidates.find(candidate => candidate.category !== best.category);
  if (
    !selectedCategory &&
    !requestedCategory &&
    bestOtherCategory &&
    best.score - bestOtherCategory.score <= 2 &&
    ['client', 'owner'].includes(best.category) &&
    ['client', 'owner'].includes(bestOtherCategory.category)
  ) {
    return { type: 'ambiguous', categories: ['client', 'owner'] };
  }

  return { type: 'match', ...best };
};

export { normalize };
